import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminRoute from "./components/AdminRoute";
import AuthCallback from "./components/AuthCallback";
import UnderConstruction from "./components/UnderConstruction";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Destinations from "./pages/Destinations";
import DestinationDetail from "./pages/DestinationDetail";
import Packages from "./pages/Packages";
import Trips from "./pages/Trips";
import TripDetail from "./pages/TripDetail";
import PlanMyTrip from "./pages/PlanMyTrip";
import GroupTripCalendar from "./pages/GroupTripCalendar";
import About from "./pages/About";
import Consultation from "./pages/Consultation";
import Login from "./pages/Login";
import VerifyEmail from "./pages/VerifyEmail";
import CheckEmail from "./pages/CheckEmail";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import AdminSetup from "./pages/AdminSetup";
import MembersDashboard from "./pages/MembersDashboard";
import AdminPanel from "./pages/AdminPanel";
import BookingSuccess from "./pages/BookingSuccess";
import Policies from "./pages/Policies";
import ItineraryViewer from "./pages/ItineraryViewer";
import { Toaster } from "./components/ui/sonner";

// Router component that checks for OAuth callback
function AppRouter() {
  const location = useLocation();
  
  // Scroll to top on route change
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  
  // Check URL hash for session_id (OAuth callback) - do this synchronously during render
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <>
      <UnderConstruction />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/destinations" element={<Destinations />} />
        <Route path="/destinations/:id" element={<DestinationDetail />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/trips" element={<Trips />} />
        <Route path="/trips/:id" element={<TripDetail />} />
        <Route path="/plan-my-trip" element={<PlanMyTrip />} />
        <Route path="/calendar" element={<GroupTripCalendar />} />
        <Route path="/about" element={<About />} />
        <Route path="/consultation" element={<Consultation />} />
        <Route path="/booking/success" element={<BookingSuccess />} />
        <Route path="/policies" element={<Policies />} />
        <Route path="/login" element={<Login />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/check-email" element={<CheckEmail />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/admin-setup" element={<AdminSetup />} />
        <Route path="/members" element={
          <ProtectedRoute>
            <MembersDashboard />
          </ProtectedRoute>
        } />
        <Route path="/members/dashboard" element={
          <ProtectedRoute>
            <MembersDashboard />
          </ProtectedRoute>
        } />
        <Route path="/admin" element={
          <AdminRoute>
            <AdminPanel />
          </AdminRoute>
        } />
        {/* Itinerary Viewer - supports both booking_id and magic link tokens */}
        <Route path="/itinerary/:token" element={<ItineraryViewer />} />
      </Routes>
      <Footer />
      <Toaster />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
          <AuthProvider>
            <AppRouter />
          </AuthProvider>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
